import { constants } from "@config";

export function calculateColumnsWidth (textWidth, columns, gap = constants.text.columns.defaultGap) {
  const numOfColumns = Math.max(constants.text.columns.defaultColumns, columns);
  return Math.round((textWidth - (numOfColumns - 1) * gap) / numOfColumns) || 0;
}
